import Api from "./api";

class RequestService {

    api = new Api();

    getRequests(userId) {
        return this.api.post('/buyer/request/get-requests', {
            userId: userId
        });
    }

}

export default new RequestService();